<section class="hero">
  <div class="content-left">
   <div class="badge">
  <span class="gradient-text"> TechLaunchpad India:<br /> </span> 
  <span class="black-text"> Your Direct Path to an Industry-<br />Ready Tech Career.</span>
</div>


    <h1>
     The Challenge & Our Solution

    </h1>

<p class="subtext" style="font-weight: bold;">Apply Now for Our Next Batch!</p>

    <div class="buttons">
      <button class="brochure-btn">Download Brochure</button>
      <button class="video-btn"
       (click)="openCta()">  Enroll Now! </button>
    </div>
  </div>

 <div class="dashboard-image-wrapper">
  <img src="assets/images/ds-hs.png" alt="Dashboard Overview" class="dashboard-image" />
</div>
</section>
<section class="challenge-section">
  <h2 class="section-heading">The Challenge & Our Solution</h2>
<div class="challenge-cards">
  <!-- Top-left blue icon -->
  <img src="assets/images/challenge1.png" alt="icon" class="icon-top-left" />

  <!-- Bottom-right blue icon -->
  <img src="assets/images/challenge2.png" alt="icon" class="icon-bottom-right" />

  <!-- Left: The Problem Card (image only) -->
  <div class="challenge-card">
    <img src="assets/images/theproblemcard.png" alt="Problem Card" />
  </div>

  <!-- Solution Card -->
  <div class="challenge-card">
    <img src="assets/images/thesolutioncard.png" alt="Solution Card" />
  </div>
</div>

<section class="apart-section">
  <h2 class="section-heading">What Sets Us Apart</h2>

  <div class="apart-content">
    <div class="full-image">
      <img src="assets/images/upwhatsetapart.png" alt="What Sets Us Apart" />
    </div>
  </div>
</section>

<section class="placement-path">
  <h2>Your Path to Placement</h2>
  <p>Comprehensive Placement Guidance</p>

<div class="placement-image-wrapper">
  <img src="assets/images/pathtoplacement7.png" alt="Placement Steps Visual" class="placement-image">
</div>
</section>

<section class="program-for-section">

  <!-- Heading OUTSIDE the blue container -->
  <h2 class="section-heading">Who Is This Program For?</h2>

  <!-- Container with cards and image -->
  <div class="program-container">

    <!-- Cards -->
    <div class="audience-cards">
      <div class="audience-card">
        <h3><span class="audience-type student">Students</span></h3>
        <p>"Looking to add real, in-demand skills to your degree and stand out."</p>
      </div>
      <div class="audience-card">
        <h3><span class="audience-type switchers">Career Switchers</span></h3>
        <p>Ready to break into the tech industry with structured, practical training.</p>
      </div>
      <div class="audience-card">
        <h3><span class="audience-type seekers">Job Seekers</span></h3>
        <p>Want to enhance your profile with hands-on projects and robust placement preparation.</p>
      </div>
    </div>

    <!-- Image -->
    <div class="audience-image">
      <img src="assets/images/fivestudimg.png" alt="Group of people under neon light" />
    </div>

  </div>

  <!-- Button OUTSIDE the container -->
 <div class="enroll-button-wrapper">
  <button class="enroll-button" (click)="openCta()">Ready to Transform Your Career? Enroll Now!</button>
</div>


</section>

<section class="faq-section">
  <h2 class="faq-heading">FAQs</h2>

  <div class="faq-item" *ngFor="let faq of faqs; let i = index">
    <button class="faq-question" (click)="toggleFAQ(i)">
      {{ faq.question }}
      <span class="arrow" [class.rotated]="faq.open">&#9662;</span>
    </button>
    <div class="faq-answer" *ngIf="faq.open">
      <p>{{ faq.answer }}</p>
    </div>
  </div>
</section>
